/* eslint-disable prettier/prettier */
import React from 'react';
import { db, firebase } from "firebase/fbConfig.js";

import TripBuilderParent from './TripBuilderParent';

class TripEditor extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            trip: null,
            dataLoaded: false
        }
        this.tripID = window.location.pathname.split('/')[2];
    }

    componentDidMount() {
        db.collection('haneyTrips').doc(this.tripID).get()
            .then(doc => {
                console.log(doc);
                const docData = {
                    ...doc.data(),
                    id: doc.id
                }
                this.setState({
                    trip: docData,
                    dataLoaded: true
                });
            })
    }

    render() {
        return this.state.dataLoaded ? (
            <TripBuilderParent
                trip={this.state.trip}
                tripID={this.tripID}
            />
        ) : (
            <p>Loading...</p >
        );
    }
}

export default TripEditor;


// WEBPACK FOOTER //
// ./src/views/Trips/TripEditor.jsx